import "./gitlab_icon.scss";

const GitlabIcon = () => {
  return (
    <svg
      id="icon-gitlab"
      width="199"
      height="176"
      viewBox="0 0 199 176"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M195.506 69.8456L195.227 69.1956L168.192 4.92516C167.642 3.66549 166.668 2.59691 165.41 1.87274C164.151 1.16087 162.683 0.818009 161.203 0.890453C159.724 0.962896 158.304 1.44715 157.137 2.27784C155.982 3.13238 155.144 4.29031 154.737 5.59405L136.483 56.4677H62.5683L44.3145 5.59405C43.9186 4.28321 43.079 3.11948 41.9152 2.26842C40.7473 1.43773 39.3278 0.953473 37.8482 0.88103C36.3687 0.808586 34.9003 1.15145 33.6415 1.86331C32.3862 2.59041 31.4132 3.65806 30.8594 4.91573L3.77347 69.1579L3.50458 69.8079C-0.387129 79.0708 -0.867497 89.2351 2.1359 98.7683C5.1393 108.302 11.4636 116.687 20.1554 122.66L20.2484 122.726L20.4967 122.886L61.6789 150.98L82.0529 165.027L94.4634 173.562C95.9151 174.566 97.6876 175.11 99.5103 175.11C101.333 175.11 103.106 174.566 104.557 173.562L116.968 165.027L137.342 150.98L178.772 122.717L178.876 122.641C187.548 116.667 193.858 108.29 196.856 98.7698C199.855 89.2495 199.381 79.0997 195.506 69.8456V69.8456Z"
        fill="#E24329"
      />
      <path
        className="eyes-1"
        d="M195.506 69.8456L195.227 69.1956C182.054 71.6586 169.641 76.7414 158.874 84.0808L99.5 124.978C119.719 138.911 137.321 151.017 137.321 151.017L178.752 122.754L178.855 122.679C187.54 116.705 193.859 108.323 196.862 98.7942C199.865 89.2657 199.389 79.1064 195.506 69.8456Z"
        fill="#FC6D26"
      />
      <path
        d="M61.6789 151.017L82.0529 165.064L94.4634 173.6C95.9151 174.604 97.6877 175.147 99.5103 175.147C101.333 175.147 103.106 174.604 104.557 173.6L116.968 165.064L137.342 151.017C137.342 151.017 119.719 138.874 99.5 124.978C79.2812 138.874 61.6789 151.017 61.6789 151.017Z"
        fill="#FCA326"
      />
      <path
        className="eyes-2"
        d="M40.1156 84.0808C29.3577 76.7263 16.9473 71.6303 3.77347 69.1579L3.50458 69.808C-0.387129 79.0708 -0.867497 89.2351 2.1359 98.7683C5.1393 108.302 11.4636 116.687 20.1554 122.66L20.2484 122.726L20.4967 122.886L61.6789 150.98C61.6789 150.98 79.2605 138.874 99.5 124.94L40.1156 84.0808Z"
        fill="#FC6D26"
      />
    </svg>
  );
};

export default GitlabIcon;
